import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { TableFooter, TablePagination, TableRow } from '@mui/material';
import ReuseableTableHeader from './ReuseableTableHeader';
import ReuseableTableRow from './ReuseableTableRow';
import { Row } from '../../interfaces';
import { HeaderCells, Sort, Pagination } from '../../types/ui';

interface Props {
  headerCells: HeaderCells;
  filteredRows: Row[];
  handleRowClick?: (id: string) => void;
  pagination?: Pagination;
  sort?: Sort;
  small?: boolean;
}

export default function TableContent({
  headerCells,
  filteredRows,
  handleRowClick,
  pagination,
  sort,
  small,
}: Props) {
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    pagination?.setPage(newPage);
  };

  const hasNext = pagination?.hasNext ?? true;
  const hasPrevious = pagination?.hasPrevious ?? true;

  return (
    <TableContainer component={Paper}>
      <Table>
        <ReuseableTableHeader cells={headerCells} sort={sort} small={small} />
        <TableBody>
          {filteredRows.map(row => (
            <ReuseableTableRow
              key={row.rowId}
              rowId={row.rowId}
              cells={row.cells}
              handleRowClick={handleRowClick}
            />
          ))}
        </TableBody>
        {pagination && (
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={pagination.colSpan}
                count={pagination.count}
                rowsPerPage={pagination.rowsPerPage}
                page={pagination.page}
                onPageChange={handleChangePage}
                rowsPerPageOptions={[pagination.rowsPerPage]}
                slotProps={{
                  actions: {
                    nextButton: {
                      disabled: !hasNext,
                    },
                    previousButton: {
                      disabled: !hasPrevious,
                    },
                  },
                }}
              />
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
}
